/**
 * IndexedDB compartilhado do modo offline:
 *  - apontamentos_queue: fila de envio (POST pendentes)
 *  - api_cache: última resposta de cada GET (leitura offline)
 */
const DB_NAME = "ostecnovias-offline";
const DB_VERSION = 2;
export const STORE_QUEUE = "apontamentos_queue";
export const STORE_CACHE = "api_cache";

let dbPromise = null;

export function openDB() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_QUEUE)) {
        const store = db.createObjectStore(STORE_QUEUE, { keyPath: "id", autoIncrement: true });
        store.createIndex("created_at", "created_at");
      }
      if (!db.objectStoreNames.contains(STORE_CACHE)) {
        db.createObjectStore(STORE_CACHE, { keyPath: "key" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => { dbPromise = null; reject(req.error); };
  });
  return dbPromise;
}

export async function tx(storeName, mode, fn) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(storeName, mode);
    const store = t.objectStore(storeName);
    let result;
    const req = fn(store);
    if (req && "onsuccess" in req) req.onsuccess = () => { result = req.result; };
    t.oncomplete = () => resolve(result);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  });
}

// ---------- Cache de leitura (GET) ----------
export async function cacheSet(key, data) {
  await tx(STORE_CACHE, "readwrite", (s) => s.put({ key, data, cached_at: Date.now() }));
}

export async function cacheGet(key) {
  return tx(STORE_CACHE, "readonly", (s) => s.get(key));
}

export async function cacheKeys() {
  return tx(STORE_CACHE, "readonly", (s) => s.getAllKeys());
}

export async function cacheClear() {
  await tx(STORE_CACHE, "readwrite", (s) => s.clear());
}
